import { render } from "./S139108.vue?vue&type=template&id=93fc356c"
const script = {}
script.render = render

export default script